var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-dialog',{attrs:{"dialog":_vm.dialog},on:{"submit":_vm.submitForm}},[_c('base-lesson-form',{attrs:{"lesson":_vm.lesson},on:{"change":_vm.syncChanges}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }